import { getSessionItem } from '../../../services/browser-storage';
import { eID } from '../../../services/dom';
import InputField from '../../../services/input-fields/input-field';
import Unibar from '../input-fields/unibar';
import WidgetForm, { getWidgetForm, IWidgetFormRow } from '../models/form';
import { storePlace, storeTransport } from '../quote-data';
import { BookingMode, currentMode, isDesktop } from '../storage';
import { validateRow } from '../validation/validator';
import { getSession, ISession, ISessionRoute, setSession } from './session-storage';

export default function loadSession(): void {
    // Load session into memory
    let session = getSession();
    if (session === null) {
        const stored = (getSessionItem('gete-widget') || '').trim();
        if (stored) setSession(JSON.parse(stored));
        session = getSession();
    }

    // Render session
    if (session !== null) {
        console.log('Session:', session);
        renderSession(session as ISession, getWidgetForm());
    }
}

function renderSession(session: ISession, form: WidgetForm): void {
    // Mode selection
    let mode: number | null = null;

    switch (session.bookingMode) {
        case BookingMode.DoorToDoor:
            mode = 1;
            break;
        case BookingMode.ToAirport:
            mode = 2;
            break;
        case BookingMode.FromAirport:
            mode = 3;
            break;
        default:
            if (session.bookingMode) {
                console.warn(
                    'Unknown booking mode in session:',
                    session.bookingMode);
            }
            break;
    }

    if (mode) {
        eID(`mode${mode}`).click();
    }

    // Return button
    if (session.hasReturn) {
        eID(`${isDesktop ? 'return-btn' : 'returnButton'}`).click();
    }

    // No-flight option
    if (isDesktop) {
        // TODO: No-flight not supported on mobile
        const $checkbox = form.noFlightCheck;
        const isChecked = $checkbox.prop('checked');
        const shouldCheck = session.noFlight;

        if (shouldCheck && !isChecked
            || !shouldCheck && isChecked) {
            $checkbox.click();
        } else {
            // The browser sometimes autofills the checkbox, but that does not trigger the JS listeners
            $checkbox.change();
        }
    }

    // Input fields
    const dataList: Array<{
        formRow: IWidgetFormRow,
        sessionData: ISessionRoute
    }> = [{
        formRow: form.row1,
        sessionData: session.route1
    }];

    if (session.hasReturn) {
        dataList.push({
            formRow: form.row2,
            sessionData: session.route2
        });
    }

    // Fill in all the fields
    dataList.forEach(route => {
        const inputs = route.formRow;
        const data = route.sessionData;

        // Flight addresses
        fillUnibar(inputs.fromAddress, data.fromAddress);
        fillUnibar(inputs.toAddress, data.toAddress);

        // Flight datetime
        fillField(inputs.flight.flightNumber, data.flightNumber);
        fillField(inputs.flight.flightDate, data.flightDate);

        // No flight unibars
        fillUnibar(inputs.noflight.to, data.noflight.to);
        fillUnibar(inputs.noflight.from, data.noflight.from);

        // No flight datetime
        fillField(inputs.noflight.datetime, data.noflight.dateTime);

        validateRow(inputs, currentMode.value, form.noFlightCheck.prop('checked'), route.formRow.isReturn);
    });
}

function fillField(field: InputField, value: string): void {
    field.value = value;
}

function fillUnibar(unibar: Unibar | null, point: API.ApiLocation | null): void {
    if (!unibar || !point) return;

    if (point.type === 'Place') {
        storePlace(point.id, { name: point.name });
    } else {
        storeTransport(point.id, { name: point.name });
    }

    unibar.setValue(point);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/session/session-load.ts